import { render, staticRenderFns } from "./tiny-block.vue?vue&type=template&id=441afed2&scoped=true&"
import script from "./tiny-block.vue?vue&type=script&lang=js&"
export * from "./tiny-block.vue?vue&type=script&lang=js&"
import style0 from "./tiny-block.vue?vue&type=style&index=0&id=441afed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441afed2",
  null
  
)

export default component.exports